import { render } from "./CourseIntegrations.vue?vue&type=template&id=469eb70d&ts=true"
import script from "./CourseIntegrations.vue?vue&type=script&lang=ts"
export * from "./CourseIntegrations.vue?vue&type=script&lang=ts"

import exportComponent from "/tmp/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__